import React, { useState, useEffect } from 'react';

export default function Bio({
  infos,
  handleChange,
  max,
  setShowBio,
  updateDetails,
  placeholder,
  name,
  detail,
  setShow,
  rel,
}) {
  const [remaining, setRemaining] = useState(detail ? 25 : 250);

  useEffect(() => {
    setRemaining(detail ? 25 : 250);
  }, [detail]);

  const handleInputChange = (e) => {
    handleChange(e);
    setRemaining((detail ? 25 : 250) - e.target.value.length);
  };

  // Determine account privacy from localStorage (fallback to public)
  const accountPrivacy = localStorage.getItem('accountPrivacy') || 'public';

  return (
    <div className="add_bio_wrap">
      {rel ? (
        <select
          className="select_rel"
          name={name}
          value={infos.relationship}
          onChange={handleChange}
        >
          <option value="Single">Single</option>
          <option value="In a relationship">In a relationship</option>
          <option value="Married">Married</option>
          <option value="Divorced">Divorced</option>
        </select>
      ) : (
        <textarea
          placeholder={placeholder}
          name={name}
          value={infos?.[name]}
          maxLength={detail ? 25 : 250}
          className="textarea_blue details_input"
          onChange={handleInputChange}
        ></textarea>
      )}
      {!detail && <div className="remaining">{remaining} characters remaining</div>}
      <div className="flex">
        <div className="flex flex_left">
          {accountPrivacy === 'private' ? (
            <>
              <img src="/icons/lock.png" alt="Private" style={{ width: 16, height: 16, marginRight: 6 }} />
              Private
            </>
          ) : (
            <>
              <i className="public_icon"></i>Public
            </>
          )}
        </div>
        <div className="flex flex_right">
          <button
            className="gray_btn"
            onClick={() => (!detail ? setShowBio(false) : setShow(false))}
          >
            Cancel
          </button>
          <button
            className="blue_btn"
            onClick={() => {
              updateDetails();
              if (!detail) {
                setShowBio(false);
              } else {
                setShow(false);
              }
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
